import React from 'react';
import Slider from 'react-slick';
import Featured from 'marketing/common/featured';
import partial from 'lodash/partial';
import merge from 'lodash/merge';
import { trackClickWithMixpanel } from 'common/tracking';
import ReviewsAgg from 'marketing/containers/reviews_agg';

const PrevButton = ({ onClick, eventTracking }) => (
  <span onClick={eventTracking ? partial(trackClickWithMixpanel, eventTracking.eventName, eventTracking.eventData) : () => {} }>
    <i className="fa fa-angle-left btn-prev" onClick={onClick} />
  </span>
);

const NextButton = ({ onClick, eventTracking }) => (
  <span onClick={eventTracking ? partial(trackClickWithMixpanel, eventTracking.eventName, eventTracking.eventData) : () => {} }>
    <i className="fa fa-angle-right btn-next" onClick={onClick} />
  </span>
);

const SETTINGS = {
  dots: true,
  infinite: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow: <PrevButton />,
  nextArrow: <NextButton />
};

const DEFAULT_TESTIMONIALS = [
  {
    image: 'https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_testimonial_cori-newlander.jpg',
    title: 'I can\'t speak highly enough of crowdspring.',
    quote: 'I started with a small budget and some boring content, and within a short time, I had some amazing designs to choose from. The hardest part was choosing one!',
    author: 'Cori Newlander, City of Santa Monica',
  },
  {
    image: 'https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_testimonial_christina-catalano.jpg',
    title: 'I am thrilled with the professional and eye-catching final design!',
    quote: 'I had over 100 entries that were creative, unique, and specific to my design ideas. I would asbsolutely recommend crowdspring to any professional who doesn’t have an in-office creative team.',
    author: 'Christina Catalano, Catalano & Associates',
  },
  {
    image: 'https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_testimonial_jeff-knowles.jpg',
    title: 'Crowdspring will be my first stop for my future creative needs.',
    quote: 'I’ve had great success with crowdspring, using the website to both redesign an existing website and to create a website from scratch. Both projects produced a large number of high quality design options.',
    author: 'Jeff Knowles',
  },
];

const Testimonials = ({
  items = DEFAULT_TESTIMONIALS, featured, linkEventTracking, arrowEventTracking, title
}) => (
  <section className="block block-testimonial">
    <div className="row columns">
      <div className="block-header">
        <ReviewsAgg linkEventTracking={linkEventTracking} title={title} />
      </div>
    </div>
    <div className="slider-container">
      <div className="row">
        <div className="small-16 medium-12 medium-offset-2 large-10 large-offset-3 columns">
          <Slider {...merge({}, SETTINGS, {nextArrow: <NextButton eventTracking={arrowEventTracking} />, prevArrow: <PrevButton eventTracking={arrowEventTracking} />})}>
            {items.map((item, i) => (
              <div className="testimonial" key={i}>
                <div className="quote">
                  <h3>&quot;{item.title}&quot;</h3>
                  <p className="show-for-medium">{item.quote}</p>
                </div>
                <img alt={item.author} src={item.image} className="avatar avatar-round avatar-testimonial" />
                <div className="testimonial-meta">
                  {item.author}
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
    {featured &&
      <Featured />
    }
  </section>
);

export default Testimonials;



// WEBPACK FOOTER //
// ./marketing/common/testimonial_slider.jsx